<rs-modal #modal
  (show)="show($event)"
  (submit)="submit()"
  [config]="modalConfig">

  @if (checkboxFormArray && procedureGroups?.length) {
    <div class="procedures-list">
      @for (checkbox of checkboxFormArray?.controls; track checkbox; let i = $index) {
        <div
          class="bottom-border pt-4 pb-2">
            <div class="selected-item d-flex justify-content-between align-items-center">
              <div class="selected-item-title align-items-top">
                <rs-checkbox ngDefaultControl
                  [id]="'procedure-group-' + procedureGroups[i].id"
                  [label]="procedureGroups[i].name | translate"
                  [formControl]="checkbox"
                  (change)="selectProcedureGroup($event, procedureGroups[i])">
                </rs-checkbox>
                @if (procedureGroups[i].procedures.length > 1) {
                  <button
                    type="button"
                    (click)="procedureGroups[i].open = !procedureGroups[i].open"
                    (clickOutside)="procedureGroups[i].open = false"
                    class="rs-btn-link d-flex align-items-center fw-700 stack">
                    {{ procedureGroups[i].procedures.length }}
                    {{ procedureGroups[i].procedures.length === 1 ? 'procedure' : 'procedures' }}
                  </button>
                }
              </div>
              @if (procedureGroups[i].procedures.length > 1 && procedureGroups[i].open) {
                <div
                  class="pulldown-menu p-3">
                  <div class="fw-700 fs-18 mb-3">Procedures in this group</div>
                  @for (child of procedureGroups[i].procedures; track child) {
                    <div>
                      {{ child.name | translate }}
                    </div>
                  }
                </div>
              }
            </div>
          </div>
        }
      </div>
    }

</rs-modal>